var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"right-side-inner"},[_c('table-block',{attrs:{"title":_vm.title,"actions":_vm.actions,"fields":_vm.fields,"api":_vm.api}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }